import { Box, Button, Stack, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { T } from 'GlobalStores/Cores/Translator/useTranslate'
import styled from '@emotion/styled'
import { useEffect, useState } from 'react'
import cookieAcceptanceService from 'Services/Cookie/CookieAcceptanceService'
import storeFeelGreat from 'GlobalStores/FeelGreat/StoreFeelGreat'
import { autorun} from 'mobx'
import StoreLoader from 'GlobalStores/Cores/Elements/StoreLoader'
import StoreTranslate from 'GlobalStores/Cores/Translator/StoreTranslate'

const CookieConsentBanner = styled(Box)(({ theme }) => ({
    boxSizing: 'border-box',

    position: 'fixed',
    bottom: '24px',
    right: '24px',
    maxWidth: '530px',

    backgroundColor: '#072648',

    padding: '32px',
    borderRadius: '8px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
    zIndex: 9999,

    '& .MuiTypography-root': {
        fontFamily: 'Poppins, NotoSansThai',
        color: '#FFF',
        fontWeight: 500,
        lineHeight: 1.5,

    },

    '@media (max-width: 768px)': {
        bottom: '20px',
        right: '50%',
        transform: 'translateX(50%)',
        width: 'calc(100% - 40px)',
        maxWidth: '530px'
    },

    '@media (max-width: 430px)': {
        maxWidth: '400px',
        padding: '24px',
    }
}))

const AcceptButton = styled(Button)({
    backgroundColor: '#079FF4',
    color: '#FFF',
    padding: '8px 40px',
    borderRadius: '0px',
    '&:hover': {
        backgroundColor: '#079FF4'
    },
    margin: '32px -32px 0px!important',
    width: 'calc(100% + 64px)',

    '@media (max-width: 430px)': {
        margin: '24px -24px 0px!important',
        width: 'calc(100% + 48px)',
    }
})

const PrivacyLink = styled('a')({
    color: '#079FF4',
    textDecoration: 'underline',
})

const CookieConsentModal = observer(() => {
    const [mounted, setMounted] = useState(false)
    const [isShow, setIsShow] = useState(false)

    useEffect(() => {
        // Add a small delay before showing the banner for a smooth entrance
        const timer = setTimeout(() => {
            setMounted(true)
        }, 500)
        return () => clearTimeout(timer)
    }, [])

    const handleAccept = () => {
        cookieAcceptanceService.setAcceptedCookie(true)
        setIsShow(false)
    }


    useEffect(() => {

        const disposer = autorun(() => {

            if (storeFeelGreat.contents.cookieSettings.isEnable && StoreLoader.IsWebReady()) {
                if (cookieAcceptanceService.isAcceptedCookie()) {
                    setIsShow(false)
                } else {
                    setIsShow(true)
                }
            }

        })

        return () => {
            disposer()

        }

    }, [])


    return (
        <>
            {isShow ?

                <CookieConsentBanner
                    sx={{
                        opacity: mounted ? 1 : 0,
                        transform: mounted ?
                            'translateY(0)' :
                            'translateY(20px)',
                        transition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out'
                    }}
                >
                    <Stack spacing={2}>
                        <Typography
                            component={'p'}
                            sx={{
                                fontSize: '14px',
                            }}
                        >
                            <T>cookie_consent_message</T>&nbsp;

                            <PrivacyLink
                                href={StoreTranslate.UseLanguage(storeFeelGreat.contents.cookieSettings?.cookieLink)}
                                target="_blank"
                            >
                                <T>privacy_policy</T>.
                            </PrivacyLink>
                        </Typography>

                        <AcceptButton
                            onClick={handleAccept}
                            disableRipple={true}
                        >
                            <Typography
                                component={'span'}
                                sx={{
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                }}
                            >
                                <T>accept</T>
                            </Typography>
                        </AcceptButton>
                    </Stack>
                </CookieConsentBanner>
                :
                null
            }

        </>
    )
})

export default CookieConsentModal 